import { Component, OnDestroy, Renderer2, TemplateRef } from '@angular/core';
import { ModalParams } from '../../shared/modal-params';
import { ModalService } from '../../shared/services/modal.service';
import { of, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-fullscreen-modal',
  templateUrl: './fullscreen-modal.component.html',
  styleUrls: ['./fullscreen-modal.component.scss']
})
export class FullscreenModalComponent implements OnDestroy {

  public params: ModalParams;
  public opened = false;
  public disabled = false;
  public bodyTemplate: TemplateRef<any>;
  public openSubscription: Subscription;
  public triggerResolutionSubscription: Subscription;

  private defaultParams: ModalParams = {
    title: null,
    content: null,
    closeButton: {
      text: 'Close',
      type: 'white'
    },
    validateButton: {
      displayed: true,
      text: 'Ok',
      type: 'primary'
    },
    beforeResolve: () => of({}),
  };

  constructor(private modalService: ModalService, private renderer: Renderer2) {
    this.reset();

    this.openSubscription = modalService.getOpenObservable()
      .pipe(filter(p => p.fullSize))
      .subscribe(p => {
        this.open(p);
      });

    this.triggerResolutionSubscription = modalService.getTriggerResolutionObservable()
      .pipe(filter(_ => this.opened))
      .subscribe(() => {
        this.resolve();
      })
  }

  public reset() {
    this.disabled     = false;
    this.bodyTemplate = null;
    this.params       = { ...this.defaultParams };
  }

  public open(p: ModalParams) {
    this.params       = {
      ...this.defaultParams,
      ...p,
      closeButton: { ...this.defaultParams.closeButton, ...p.closeButton },
      validateButton: { ...this.defaultParams.validateButton, ...p.validateButton }
    };
    this.opened       = true;
    this.bodyTemplate = this.params.content;
    this.renderer.addClass(document.body, 'modal-open');
  }

  public close() {
    this.opened = false;
    this.renderer.removeClass(document.body, 'modal-open');

    const emitter = this.modalService.getResolveEmitter();
    if (emitter) {
      emitter.complete();
    }

    this.reset();
  }

  public resolve() {
    this.disabled = true;
    this.params.beforeResolve()
      .pipe(take(1))
      .subscribe(() => {
        this.modalService.getResolveEmitter().next();
        this.close();
      }, () => {
        this.disabled = false;
      });
  }

  public ngOnDestroy() {
    this.openSubscription.unsubscribe();
    this.triggerResolutionSubscription.unsubscribe();
  }
}
